// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PhoneOutgoingIconSignature {
  Element: SVGSVGElement;
}

export const PhoneOutgoingIcon: TOC<PhoneOutgoingIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M18 15H14C12.923 15 12.042 15.855 12.001 16.922C9.459 16.518 7.528 14.582 7.092 11.998C8.153 11.949 9 11.072 9 10V6C9 4.896 8.103 4 7 4H3C1.897 4 1 4.896 1 6V11C1 17.617 6.383 23 13 23H18C19.103 23 20 22.104 20 21V17C20 15.896 19.104 15 18 15ZM12 4V6H16.586L10.293 12.293L11.708 13.707L18 7.414V12H20V4H12ZM3 11C3 16.514 7.486 21 13 21H18.001L18 17H14V18C14 18.553 13.552 19 13 19C8.512 19 5.073 15.567 5 11.016C4.997 10.748 5.099 10.491 5.287 10.299C5.475 10.107 5.732 10 6 10H7V6H3V11Z"/>
</svg>
</template>;